'use client';
import MaterialFormHelperText from '@mui/material/FormHelperText';
import { styled } from '@mui/material/styles';
export const FormHelperText = styled(MaterialFormHelperText)({
    margin: '3px 0 0'
});
